import { l } from '@manychat/manyui'

export const EMPTY_SEGMENT_LABEL = '...'
export const BREADCRUMBS_ROOT_NAME = l.translate('My Automations')
